import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { appointmentUrl, faqsLeft, faqsRight, type FaqItem } from "@/mocks/ppcare";

function FaqColumn({ items, initial = -1 }: { items: FaqItem[]; initial?: number }) {
  const [open, setOpen] = useState<number>(initial);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div
            key={item.question}
            className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
              isOpen ? "border-primary-300" : "border-background-200"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : index)}
              className="flex w-full cursor-pointer items-center gap-3 p-5 text-left"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">
                ?
              </span>
              <span className="flex-1 text-sm font-semibold text-foreground-900 md:text-base">
                {item.question}
              </span>
              <i
                className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-5 pl-10 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                  {item.question === "How can I schedule an appointment?" && (
                    <>
                      {" "}
                      <a
                        href={appointmentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold text-primary-600 underline underline-offset-2"
                      >
                        Book online here
                      </a>
                      .
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function FaqSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="FAQ's"
            title={
              <>
                Frequently Asked <span className="text-accent-500">Questions</span>
              </>
            }
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-14 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-6">
            <FaqColumn items={faqsLeft} initial={0} />
            <FaqColumn items={faqsRight} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}